<template>
  <!--<div>-->
  <div class="partnersMain">
    <!--banner+导航-->
    <div class="bannerBox">
      <img ref="homeBanner" src="../../../assets/img/developer.png" />
      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!--<top-nav :nav-index1="6"></top-nav>-->
      </div>
    </div>
    <div class="index01" id="m1">
      <div class="contentW animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'" id="m1">
        <div class="content_left_title">SuperiorPay API文档</div>
        <div class="tabsBox">
          <div class="tabsTitle">
            <span class="act">线下支付</span>
            <!-- <span :class="act.tabsTitleId===2 ? 'act' : ''" @click="tabsTitleClick(2)">Online</span> -->
          </div>
          <div class="tabsContent">
            <ul>
              <!-- <li class="iconLi" @mouseenter="enter1(1,1)" @mouseleave="leave1(1,0)"> -->
              <li
                class="iconLi" @mouseenter="enter1(1,1)" @mouseleave="leave1(1,0)"
                @click="linkDownload('https://doc.supaytechnology.com/CN/offline/index.html#api-User_present_code')"
              >
                <div v-show="show.shows1===0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_instore1.png" />
                  </div>
                  <div class="textDiv">店内二维码</div>
                </div>
                <div v-show="show.ids1===1 && show.shows1===1" class="borderDiv border">
                  <div class="textTitle">店内二维码</div>
                  <div class="textContent">消费者可以通过扫描店内静态二维码，并输入所购商品金额以进行付款</div>
                </div>
              </li>
              <li
                class="iconLi" @mouseenter="enter2(2,1)" @mouseleave="leave2(2,0)"
                @click="linkDownload('https://doc.supaytechnology.com/CN/offline/index.html#api-User_present_code')"
              >
                <div v-show="show.shows2===0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_instore2.png" />
                  </div>
                  <div class="textDiv">智能移动收款机</div>
                </div>
                <div v-show="show.ids2===2 && show.shows2===1" class="borderDiv border">
                  <div class="textTitle">智能移动收款机</div>
                  <div class="textContent">智能移动收款机可以生成动态二维码由消费者扫码支付，或者扫取消费者支付宝/微信支付付款码直接收款</div>
                </div>
              </li>
              <li
                class="iconLi" @mouseenter="enter3(3,1)" @mouseleave="leave3(3,0)"
                @click="linkDownload('https://doc.supaytechnology.com/CN/offline/index.html#api-User_present_code-bToC')"
              >
                <div v-show="show.shows3===0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_instore3.png" />
                  </div>
                  <div class="textDiv">POS零售系统商</div>
                </div>
                <div v-show="show.ids3===3 && show.shows3===1" class="borderDiv border">
                  <div class="textTitle">POS零售系统商</div>
                  <div class="textContent">我们支持商户将自家使用的POS系统接入SuperiorPay支付，拥有SuperiorPay POS系统的同样功能</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="tabsBox" style="margin-top:20px;">
          <div class="tabsTitle">
            <!-- <span :class="act.tabsTitleId===1 ? 'act' : ''" @click="tabsTitleClick(1)">Instore</span> -->
            <span class="act" @click="tabsTitleClick(2)">线上支付</span>
          </div>
          <div class="tabsContent">
            <ul>
              <!-- <li class="iconLi" @mouseenter="enter1(1,1)" @mouseleave="leave1(1,0)"> -->
              <li
                class="iconLi" @mouseenter="enter4(4,1)" @mouseleave="leave4(4,0)"
                @click="linkDownload('https://doc.supaytechnology.com/CN/h5/index.html')"
              >
                <div v-show="show.shows4===0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_online1.png" />
                  </div>
                  <div class="textDiv">第三方收银台</div>
                </div>
                <div v-show="show.ids4===4 && show.shows4===1" class="borderDiv border">
                  <div class="textTitle">第三方收银台</div>
                  <div class="textContent">用于PC端口，用户在PC端网页跳转支付宝/微信支付第三方收银页面进行支付</div>
                </div>
              </li>
              <li
                class="iconLi" @mouseenter="enter5(5,1)" @mouseleave="leave5(5,0)"
                @click="linkDownload('https://doc.supaytechnology.com/CN/h5/index.html')"
              >
                <div v-show="show.shows5===0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_online2.png" />
                  </div>
                  <div class="textDiv">H5端口</div>
                </div>
                <div v-show="show.ids5===5 && show.shows5===1" class="borderDiv border">
                  <div class="textTitle">H5端口</div>
                  <div class="textContent">用于移动设备端口，用户与移动端网页付款，并跳转支付宝/微信支付App内进行支付</div>
                </div>
              </li>
              <li
                class="iconLi" @mouseenter="enter6(6,1)" @mouseleave="leave6(6,0)"
                @click="linkDownload('https://doc.supaytechnology.com/CN/online/index.html#api-_')"
              >
                <div v-show="show.shows6===0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_online3.png" />
                  </div>
                  <div class="textDiv">SDK端口</div>
                </div>
                <div v-show="show.ids6===6 && show.shows6===1" class="borderDiv border">
                  <div class="textTitle">SDK端口</div>
                  <div class="textContent">用于移动设备App端口，用户直接在设备App内进行支付</div>
                </div>
              </li>
              <li
                class="iconLi" @mouseenter="enter7(7,1)" @mouseleave="leave7(7,0)"
                @click="linkDownload('https://doc.supaytechnology.com/CN/online/index.html#api-Payment_Interface_Description-programPlaceOrder')"
              >
                <div v-show="show.shows7===0" class="borderDiv">
                  <div class="iconDiv">
                    <img src="../../../assets/icon/home_online4.png" />
                  </div>
                  <div class="textDiv">JSAPI端口</div>
                </div>
                <div v-show="show.ids7===7 && show.shows7===1" class="borderDiv border">
                  <div class="textTitle">JSAPI端口</div>
                  <div class="textContent">用于移动设备App内小程序端口，用户可以在小程序内直接进行支付</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--底部-->
    <Footer></Footer>
  </div>
  <!--</div>-->
</template>

<script>
import topNav from "./navCn";
import Footer from "@/components/Footer"
let timer = null; //定义初始值
export default {
  name: "DevelopersCn",
  components: { topNav,Footer },
  props: {
    step: {
      //此数据是控制动画快慢的
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      act: {
        tabsTitleId: 1
      },
      show: {
        ids1: 0,
        shows1: 0,
        ids2: 0,
        shows2: 0,
        ids3: 0,
        shows3: 0,
        ids4: 0,
        shows4: 0,
        ids5: 0,
        shows5: 0,
        ids6: 0,
        shows6: 0,
        ids7: 0,
        shows7: 0
      },
      animates: {
        mm1: false,
        mm2: false,
        mm3: false,
        mm4: false,
        mm5: false,
        mm6: false
      }
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    document.documentElement.scrollTop = 0;

    this.animates.mm1 = true;
  },
  methods: {
    //  tabs切换
    tabsTitleClick(index) {
      this.act.tabsTitleId = index;
    },
     //  点击导航
      navClick(url){
        this.$router.push(url);
      },
    //打开新连接
    linkDownload(url) {
      window.open(url, "_blank"); // 新窗口打开外链接
    },
    //置顶
    toTop() {
      // 动画

      timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        // this.isTop = true
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    //  板块1鼠标移入移出
    enter1(id, show) {
      this.show.ids1 = id;
      this.show.shows1 = show;
    },
    leave1(id, show) {
      this.show.ids1 = id;
      this.show.shows1 = show;
    },
    enter2(id, show) {
      this.show.ids2 = id;
      this.show.shows2 = show;
    },
    leave2(id, show) {
      this.show.ids2 = id;
      this.show.shows2 = show;
    },
    enter3(id, show) {
      this.show.ids3 = id;
      this.show.shows3 = show;
    },
    leave3(id, show) {
      this.show.ids3 = id;
      this.show.shows3 = show;
    },
    enter4(id, show) {
      this.show.ids4 = id;
      this.show.shows4 = show;
    },
    leave4(id, show) {
      this.show.ids4 = id;
      this.show.shows4 = show;
    },
    enter5(id, show) {
      this.show.ids5 = id;
      this.show.shows5 = show;
    },
    leave5(id, show) {
      this.show.ids5 = id;
      this.show.shows5 = show;
    },
    enter6(id, show) {
      this.show.ids6 = id;
      this.show.shows6 = show;
    },
    leave6(id, show) {
      this.show.ids6 = id;
      this.show.shows6 = show;
    },
    enter7(id, show) {
      this.show.ids7 = id;
      this.show.shows7 = show;
    },
    leave7(id, show) {
      this.show.ids7 = id;
      this.show.shows7 = show;
    }
  }
};
</script>

<style scoped>
body {
  min-width: 1345px;
}

.partnersMain {
  width: 100%;
  height: auto;
}
.partnersMain .bannerBox {
  width: 100%;
  height: auto;
  position: relative;
}
.partnersMain .bannerBox > img {
  width: 100%;
}
.partnersMain .bannerBox .topTextBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.partnersMain .bannerBox .topTextBox .bannerText1 {
  height: 7rem;
  text-align: center;
  margin-top: 12%;
}
.partnersMain .bannerBox .topTextBox .bannerText1 > img {
  width: 14rem;
}

/*内容部分*/
.partnersContent {
  width: 100%;
  height: auto;
  padding: 5rem 0 10rem 0;
  background-color: #fff;
}
.partnersContent .titleBox {
  width: 70%;
  margin: 3rem auto 1rem auto;
  line-height: 2rem;
  font-family: OpenSans300;
  color: #000;
  font-size: 1.5rem;
}
.partnersContent .textBox {
  width: 70%;
  margin: 1rem auto;
  line-height: 1.5rem;
  padding: 1rem 0;
  font-family: MontserratRegular;
  color: #4a4a4a;
  font-size: 0.875rem;
}

.hideBox {
  display: none;
}
.titleBox .logoUl {
  width: 100%;
  height: 4rem;
}
.titleBox .logoUl > li {
  float: left;
  width: 33.3%;
  height: 100%;
  display: flex;
  align-items: center;
}
.titleBox .logoUl > li > img {
  align-items: center;
  margin: auto;
}
.paytype {
  width: 70%;
  margin: 1rem auto;
  line-height: 1.5rem;
  padding: 1rem 0;
  font-family: PingFangMedium;
  color: #4a4a4a;
  font-size: 2rem;
}
.bt-line {
  border: rgba(134, 131, 131, 0.466) solid 1px;
  margin: 80px auto;
  width: 70%;
}
/*板块1*/
.index01 {
  height: auto;
  background-color: #fff;
  padding: 3rem 0;
}
.index01 .tabsBox {
  width: 100%;
  height: auto;
}
.index01 .tabsBox .tabsTitle {
  width: 100%;
  height: 2rem;
  line-height: 2rem;
  border-bottom: 1px solid #dbdbdb;
  font-family: MontserratMedium;
}
.index01 .tabsBox .tabsTitle > span {
  font-size: 1rem;
  color: #4a4a4a;
  padding: 0 0.7rem;
  display: inline-block;
  margin-right: 1rem;
  cursor: pointer;
}
.index01 .tabsBox .tabsTitle > span.act {
  border-bottom: 2px solid #f05423;
}
.index01 .tabsBox .tabsContent {
  width: 100%;
  height: 16rem;
}
.index01 .tabsBox .tabsContent > ul {
  width: 100%;
  height: 100%;
}
.index01 .tabsBox .tabsContent > ul .iconLi {
  width: 25%;
  height: 100%;
  float: left;
  cursor: pointer;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv {
  width: 80%;
  height: calc(100% - 2px);
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv .iconDiv {
  width: 100%;
  text-align: center;
  margin-top: 5rem;
  margin-bottom: 1rem;
  height: 6rem;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv .iconDiv > img {
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv .textDiv {
  width: 100%;
  text-align: center;
  font-size: 1rem;
  color: #4a4a4a;
  font-family: MontserratMedium;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv .btnDiv {
  margin: 6.5rem auto;
  color: #fff;
  font-size: 0.97rem;
  background-color: #083358;
  font-family: MontserratMedium;
  width: 8rem;
  text-align: center;
  border-radius: 4px;
  height: 2.5rem;
  line-height: 2.5rem;
  cursor: pointer;
}

.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv.border {
  box-shadow: -2px 0 7px -1px #dadada, 0 -2px 0px -1px rgba(0, 0, 0, 0),
    0 2px 7px -1px #dadada, 2px 0 7px -1px #dadada;
  padding-top: 1rem;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv.border .textTitle {
  width: 10rem;
  margin: auto;
  font-family: MontserratMedium;
  font-size: 1rem;
  color: #4a4a4a;
  text-align: center;
  line-height: 3rem;
}
.index01 .tabsBox .tabsContent > ul .iconLi .borderDiv.border .textContent {
  width: 10rem;
  margin: auto;
  font-family: Montserrat300;
  font-size: 0.875rem;
  color: #515151;
  text-align: center;
  line-height: 1.5rem;
}
/*内容部分左侧标题*/
.content_left_title {
  font-size: 1.5rem;
  color: #4a4a4a;
  height: 5rem;
  line-height: 5rem;
  width: 100%;
  font-family: OpenSans600;
}
.uline{
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
</style>
